import { useAuthStore } from "@/states/auth";
import { Navigate, useLocation } from "react-router";

import { useMyUser } from "@/actions/user.actions";
import { canAccessAdminPanel, canAccessOrg } from "@/lib/permissions";
import { ReactNode } from "react";

/** Checks route permissions using the session profile while tenant profiles refresh. */
const PrivateRoute = ({ children }: { children: ReactNode }) => {
  const token = useAuthStore((state) => state.token);
  const sessionUser = useAuthStore((state) => state.user);
  const { data: refreshedUser } = useMyUser(token);
  const user = sessionUser?.role === "super_admin" ? sessionUser : (refreshedUser || sessionUser);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (user && location.pathname.startsWith("/admin") && !canAccessAdminPanel(user.role)) {
    return <Navigate to="/" replace />;
  }

  if (user && location.pathname.startsWith("/org") && !canAccessOrg(user.role)) {
    return <Navigate to="/" replace />;
  }

  if (user && (location.pathname.startsWith("/agencies") || location.pathname.startsWith("/org/agencies")) && !canAccessOrg(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export { PrivateRoute };
